export const experiences = [
  {
    title: 'EverTrue',
    role: 'Software Engineer',
    desc: 'Shipping features for Signal, a donor management platform used by 200+ universities and nonprofits. React, TypeScript, GraphQL, Python, AWS — and a lot of AI-powered tooling.',
    when: 'Apr 2023 - Present',
    link: 'https://www.evertrue.com/',
  },
  {
    title: 'Township',
    role: 'Sr. Software Engineer',
    desc: 'Tech lead on a 3-engineer team. Offline-first mobile apps, Next.js marketing sites, full-stack Elixir/Phoenix — from Figma to production.',
    when: 'Nov 2021 - Nov 2023',
    link: 'https://www.township.agency/',
  },
  {
    title: 'Freelance',
    role: 'Web Developer',
    desc: 'Shopify, React, open source, custom portfolios, wedding websites, promotional websites, web design, UI/UX, and more.',
    when: '2020 - Present',
    link: 'https://www.linkedin.com/in/perry-von-rosenvinge-65a27a89/',
  },
  {
    title: 'Marin Software',
    role: 'Software Engineer Intern',
    desc: 'Migrated a legacy AngularJS codebase to Angular v15 across a 100+ engineer org.',
    when: 'Apr 2021 - Aug 2021',
    link: 'https://www.marinsoftware.com/',
  },
  {
    title: 'Life',
    role: 'Photography, Songwriting, Food',
    desc: 'A Few of my favorite things!',
    when: '1995 - present',
    func: true,
    special: true,
  },
];

export const skills = [
  'TypeScript',
  'JavaScript',
  'React',
  'Node.js',
  'Next.js',
  'Python',
  'AWS',
  'GraphQL',
  'React Native',
  'Tailwind CSS',
  'CI/CD',
  'Figma',
  'Expo',
  'TanStack Query',
  'Elixir/Phoenix',
  'Vue',
  'Django',
  'Firebase',
  'Vercel',
  'Datadog',
  'LaunchDarkly',
  'Contentful',
  'Angular',
  'Twilio',
  'Electron',
  'SASS',
  'Shopify',
  'Mentorship',
  'Team Building',
];

export const projects = [
  {
    title: 'Fescue Golf Club ⛳',
    stack: 'Next.js / Supabase / Sanity / Shopify / Resend',
    desc: 'Full-stack platform for a private golf simulator club — invite-only member portal, real-time bay reservations, Sanity CMS, Shopify merch store, automated emails via Resend, and a CI/CD pipeline that ships itself to production.',
    internalPath: '/fescue',
  },
  {
    title: 'Signal by EverTrue 📊',
    stack: 'React / CoffeeScript / GraphQL',
    desc: 'Reporting dashboards, AI-driven suggestions, and automated client onboarding for 200+ universities and nonprofits.',
    link: 'https://www.evertrue.com/signal/',
  },
  {
    title: 'EMPWR iOS App 📱',
    stack: 'React Native / Expo / AWS S3',
    desc: 'Offline-first field app for technicians. Led a 3-engineer team, reduced critical crashes ~40% with S3-backed image caching.',
    link: 'https://www.chargerhelp.com/',
  },
  {
    title: 'EverTrue CRM Overhaul 🔄',
    stack: 'TypeScript / Python / Salesforce',
    desc: 'Replaced manual CSV imports with automated Salesforce, Ascend, and Blackbaud syncs on scheduled timelines.',
    link: 'https://www.evertrue.com/',
  },
  {
    title: 'Moveprice 📦',
    stack: 'Elixir / Phoenix / Twilio',
    desc: 'Full-stack moving coordination app with Twilio SMS, real-time PubSub scheduling, and custom admin dashboards.',
    link: 'https://www.township.agency/',
  },
  {
    title: 'Radix Wallet 🏦',
    stack: 'Electron / Vue / Ledger',
    desc: 'Refactored multi-device Ledger hardware wallet support and optimized large dataset rendering with smart pagination.',
    link: 'https://www.radixdlt.com/',
  },
];

export const facts = [
  {
    title: 'Hobbies',
    points: ['Songwriting', 'Photography', 'Yoga'],
  },
  {
    title: 'Interests',
    points: ['Food', 'Art', 'Grateful Dead'],
  },
  {
    title: 'Goals',
    points: ['Play more guitar', 'Shoot an eagle (golf)', 'Beat Dark Souls 3'],
  },
];
